/*
 * @Author: wangqiong 2650366496@qq.com
 * @Date: 2025-09-22 13:56:48
 * @LastEditors: wangqiong 2650366496@qq.com
 * @LastEditTime: 2025-09-29 13:20:09
 * @FilePath: \hlweb2.0\src\pages\SuccessStories\Banner\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { useState, useEffect } from "react";
import { Image, Button } from "antd";
import { useTranslation } from "react-i18next";
import { JumpApply } from "../../../components/Jump";
import "./index.scss";
function Banner({ bannerObj, hideBanBtn }) {
  const { t } = useTranslation();
  const successOperations = t("successOperations", {
    returnObjects: true,
  });
  return (
    <div className="success_banner_side">
      <div className="success_banner_con">
        <div className="banner-til">{successOperations.title}</div>
        <ul className="banner-detail">
          {successOperations.detail.map((item, index) => {
            return (
              <li key={index}>
                <span>{item}</span>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}

export default Banner;
